"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("Dashboard/DashboardState.ng.html");
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
var DashboardMount_1 = __importDefault(require("./DashboardMount"));
exports.default = angular.module("qwilr.dashboard", ["ui.router"]).config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise("/pages");
    $stateProvider
        .state("dashboard", {
        url: "/{nav:pages|blocks|reports|templates|engagement-library|automations}",
        params: {
            nav: "pages",
            squash: true,
            savedBlockParams: {},
        },
        templateUrl: "Dashboard/DashboardState.ng.html",
        controller: function ($scope, $rootScope, $stateParams) {
            var di = $rootScope.di.child();
            return di.invoke(function (projectLiveLimit, initSubscription, stringManipulater, isMobile, $state) {
                if (($stateParams === null || $stateParams === void 0 ? void 0 : $stateParams.nav) === "blocks" && isMobile()) {
                    return $state.go("dashboard", { nav: "pages" });
                }
                $scope.ui = {
                    dashboard: di.invoke(DashboardMount_1.default),
                    showLiveLimitMessage: function () {
                        return projectLiveLimit.getOverLimitAmount() > 0;
                    },
                    liveLimitPhrase: function () {
                        return stringManipulater.pluralise(projectLiveLimit.getOverLimitAmount, "project");
                    },
                    explorePlans: function () {
                        return initSubscription.init();
                    },
                };
            });
        },
    })
        .state("dashboardProjectAction", {
        url: "/pages/:action/:projectId",
        templateUrl: "Dashboard/DashboardState.ng.html",
        controller: function ($rootScope, $stateParams) {
            return $rootScope.di.invoke(function (projectService, loadingIndicator, state, projectApiService, pageResourceApiService, projectTelemetry, user, rootDataStore, genericHost) {
                return projectService.getProject($stateParams.projectId).then(function (project) {
                    var projectStore = new ProjectStore_1.default(project, projectApiService, pageResourceApiService, user, projectTelemetry, rootDataStore, genericHost);
                    loadingIndicator.hide();
                    if (["share", "pdf", "analytics"].includes($stateParams.action)) {
                        return state.goToProjectAction($stateParams.action, projectStore, "dashboard");
                    }
                    else {
                        return $state.go("dashboard", { nav: "pages" });
                    }
                });
            });
        },
    })
        .state("dashboardOld", {
        url: "/projects",
        templateUrl: "Dashboard/DashboardState.ng.html",
        controller: function ($location) {
            return $location.path("/pages");
        },
    })
        .state("dashboardProjectActionOld", {
        url: "/projects/:action/:projectId",
        templateUrl: "Dashboard/DashboardState.ng.html",
        controller: function ($location, $stateParams) {
            return $location.path("/pages/".concat($stateParams.action, "/").concat($stateParams.projectId));
        },
    });
});
